var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-notification',{attrs:{"title":'יש בעיה בתזרים',"text":'המידע שהגיע מהבנק על ההוצאות בכרטיסי האשראי שלך לא עדכני.',"icon-type":'danger',"notification-buttons":[
                      {
                        title:'מה אפשר לעשות?',
                        variant: 'primary',
                        size: 'slim',
                        action: _vm.openBankCcBugModal,
                      } ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }